/* istanbul ignore file */
/* eslint-disable max-lines,quotes */
/*
    The file is auto-generated by graphql-codegen.
    Please use `yarn update-schema`
*/

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTimeTimestamp: any;
  TimeDeltaTimestamp: any;
  Upload: any;
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  code: Scalars['ID'];
  name: Scalars['String'];
  attemptsRemains: Scalars['Int'];
  studentsLimit: Scalars['Int'];
  membershipType?: Maybe<Scalars['String']>;
  receiveReports: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  allowRetries: Scalars['Boolean'];
  textLogo?: Maybe<Scalars['String']>;
  users?: Maybe<Array<User>>;
};

export type AccountBase = {
  __typename?: 'AccountBase';
  id: Scalars['ID'];
  code: Scalars['ID'];
  name: Scalars['String'];
};

export type Action = {
  id: Scalars['ID'];
};

export type ActionResult = {
  __typename?: 'ActionResult';
  actionId: Scalars['ID'];
  branchId?: Maybe<Scalars['ID']>;
  duration: Scalars['TimeDeltaTimestamp'];
  attempts: Scalars['Int'];
  isSkipped: Scalars['Boolean'];
  usedHint: Scalars['Boolean'];
  passed: Scalars['Boolean'];
  audio?: Maybe<Scalars['String']>;
  pitchRangeRatio?: Maybe<Scalars['Float']>;
  pitchRange?: Maybe<PitchRange>;
  speechSpeedRatio?: Maybe<Scalars['Float']>;
  speechSpeed?: Maybe<SpeechSpeed>;
  freeSpeechMessage?: Maybe<Scalars['String']>;
};

export type Avatar = {
  __typename?: 'Avatar';
  id: Scalars['ID'];
  gender: Gender;
  name: Scalars['String'];
  preview: Scalars['String'];
  previewFull: Scalars['String'];
  modelType: AvatarModelType;
  gltfAsset: Scalars['String'];
};


export type AvatarNameArgs = {
  languageCode?: Maybe<LanguageCode>;
};

export type AvatarAction = Action & {
  __typename?: 'AvatarAction';
  id: Scalars['ID'];
  audio?: Maybe<Scalars['String']>;
  isCustomAudio: Scalars['Boolean'];
  media?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  onlyFirstLevel: Scalars['Boolean'];
  emotion: AvatarEmotion;
  gesture: AvatarGesture;
};

export type AvatarActionInput = {
  text?: Maybe<Scalars['String']>;
  emotion?: Maybe<AvatarEmotion>;
  gesture?: Maybe<AvatarGesture>;
  customAudio?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Scalars['Upload']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  onlyFirstLevel?: Maybe<Scalars['Boolean']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};

/** An enumeration. */
export enum AvatarEmotion {
  IDLE = 'IDLE',
  SURPRISED = 'SURPRISED',
  ANGRY = 'ANGRY',
  DISAPPOINTED = 'DISAPPOINTED',
  SMILING = 'SMILING'
}

/** An enumeration. */
export enum AvatarGesture {
  IDLE = 'IDLE',
  POINT_RIGHT = 'POINT_RIGHT',
  AGREEMENT = 'AGREEMENT',
  NARRATIVE = 'NARRATIVE',
  RIGHTLY = 'RIGHTLY',
  NO = 'NO',
  THUMBS_UP = 'THUMBS_UP',
  CONFUSION = 'CONFUSION',
  STRONG_NO = 'STRONG_NO',
  SUFFERING = 'SUFFERING',
  ANNOYANCE = 'ANNOYANCE',
  APATHY = 'APATHY',
  ASSURANCE = 'ASSURANCE',
  DESPONDENCY = 'DESPONDENCY',
  DISCUSSION = 'DISCUSSION',
  GREETINGS = 'GREETINGS',
  REGRET = 'REGRET',
  TRUST = 'TRUST'
}

/** An enumeration. */
export enum AvatarModelType {
  UNKNOWN = 'UNKNOWN',
  ICLONE = 'ICLONE',
  WOLF3D = 'WOLF3D'
}

export type ChoiceUserInputAction = Action & {
  __typename?: 'ChoiceUserInputAction';
  id: Scalars['ID'];
  branches: Array<ChoiceUserInputBranch>;
};

export type ChoiceUserInputActionInput = {
  beforeActionId?: Maybe<Scalars['ID']>;
  branches?: Maybe<Array<ChoiceUserInputBranchInput>>;
};

export type ChoiceUserInputBranch = {
  __typename?: 'ChoiceUserInputBranch';
  id: Scalars['ID'];
  userInput: UserInputAction;
  avatarReaction?: Maybe<AvatarAction>;
  systemReaction?: Maybe<SystemAction>;
  state: ChoiceUserInputBranchState;
  customScore?: Maybe<Scalars['Int']>;
  customParameter?: Maybe<Scalars['String']>;
  targetScenarioId?: Maybe<Scalars['ID']>;
};

export type ChoiceUserInputBranchInput = {
  expectedText?: Maybe<Scalars['String']>;
  analogTexts?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<ChoiceUserInputBranchState>;
  customScore?: Maybe<Scalars['Int']>;
  customParameter?: Maybe<Scalars['String']>;
  targetScenarioId?: Maybe<Scalars['ID']>;
  hasAvatarReaction?: Maybe<Scalars['Boolean']>;
  hasSystemReaction?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ChoiceUserInputBranchState {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  INTERRUPT = 'INTERRUPT'
}

export type Contract = {
  __typename?: 'Contract';
  expireAt: Scalars['DateTimeTimestamp'];
  licensesCount: Scalars['Int'];
  licensesUsed: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type Course = {
  __typename?: 'Course';
  id: Scalars['ID'];
  name: Scalars['String'];
  accessToken: Scalars['String'];
  languageCode: LanguageCode;
  isInitial?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTimeTimestamp'];
  lastUpdatedAt: Scalars['DateTimeTimestamp'];
  lessons: Array<Lesson>;
  canPlay?: Maybe<Scalars['Boolean']>;
  hasPassed?: Maybe<Scalars['Boolean']>;
};

export type CourseInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
};

/** An enumeration. */
export enum CustomerType {
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  ENTREPRENEUR = 'ENTREPRENEUR',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type CutWordsDictionary = {
  __typename?: 'CutWordsDictionary';
  id: Scalars['ID'];
  name: Scalars['String'];
  cutWordPairs?: Maybe<Scalars['String']>;
};

export type CutWordsDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  cutWordPairs?: Maybe<Scalars['String']>;
};

export type DashboardDataByLesson = {
  __typename?: 'DashboardDataByLesson';
  name?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['Int']>;
  started?: Maybe<Scalars['Int']>;
  passed?: Maybe<Scalars['Int']>;
  avgScore?: Maybe<Scalars['Float']>;
  avgFeedbackScore?: Maybe<Scalars['Float']>;
  avgTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
  sum?: Maybe<Scalars['Float']>;
};

export type DashboardDataFilterInput = {
  email?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  lessonsIds?: Maybe<Array<Scalars['ID']>>;
  coursesIds?: Maybe<Array<Scalars['ID']>>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  daysAmount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DashboardDataType {
  STARTED_TO_ALL = 'STARTED_TO_ALL',
  PASSED_TO_STARTED = 'PASSED_TO_STARTED',
  NO_HINTS_TO_PASSED = 'NO_HINTS_TO_PASSED',
  FAIL_REASONS = 'FAIL_REASONS',
  SESSIONS = 'SESSIONS',
  LESSONS_STATUS = 'LESSONS_STATUS',
  AVG_FEEDBACK = 'AVG_FEEDBACK',
  AVG_FEEDBACK_BY_LESSON = 'AVG_FEEDBACK_BY_LESSON',
  AVG_SCORE = 'AVG_SCORE',
  AVG_SCORE_BY_LESSON = 'AVG_SCORE_BY_LESSON',
  AVG_TIME_BY_LESSON = 'AVG_TIME_BY_LESSON'
}


export type DetailedSessionFeedback = {
  __typename?: 'DetailedSessionFeedback';
  recognition?: Maybe<Scalars['Boolean']>;
  performance?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['Boolean']>;
  difficulty?: Maybe<Scalars['Boolean']>;
  hardware?: Maybe<Scalars['Boolean']>;
};

export type DetailedSessionFeedbackInput = {
  recognition?: Maybe<Scalars['Boolean']>;
  performance?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['Boolean']>;
  format?: Maybe<Scalars['Boolean']>;
  difficulty?: Maybe<Scalars['Boolean']>;
  hardware?: Maybe<Scalars['Boolean']>;
};

export type Editor = User & {
  __typename?: 'Editor';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  demoAccessed: Scalars['Boolean'];
  demoDaysRemaining?: Maybe<Scalars['Int']>;
  isEmailActivated?: Maybe<Scalars['Boolean']>;
};

export enum EditorAccessType {
  FULL_ACCESS = 'FULL_ACCESS',
  DEMO_ACCESS = 'DEMO_ACCESS',
  EXPIRED_DEMO_ACCESS = 'EXPIRED_DEMO_ACCESS'
}

export type EducationMemberFilterInput = {
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  lessonId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  completed?: Maybe<Scalars['Boolean']>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  daysAmount?: Maybe<Scalars['Int']>;
  adminFilter?: Maybe<Scalars['Boolean']>;
};

export type EducationMemberRow = {
  __typename?: 'EducationMemberRow';
  id: Scalars['ID'];
  participations: Array<Participation>;
  user: User;
  averageScore?: Maybe<Scalars['Float']>;
  averageFeedbackScore?: Maybe<Scalars['Float']>;
  attemptsCount?: Maybe<Scalars['Int']>;
};

export type EducationMembersPaginatedList = {
  __typename?: 'EducationMembersPaginatedList';
  items: Array<EducationMemberRow>;
  countItems: Scalars['Int'];
};

export type EducationMembersSummary = {
  __typename?: 'EducationMembersSummary';
  total: Scalars['Int'];
  active: Scalars['Int'];
};

export enum EducationSessionErrorReason {
  NO_ANSWER = 'NO_ANSWER',
  WRONG_ANSWER = 'WRONG_ANSWER',
  BAD_WORD = 'BAD_WORD',
  TIME_EXPIRED = 'TIME_EXPIRED',
  WRONG_CHOICE = 'WRONG_CHOICE',
  MISSING_KEYWORD = 'MISSING_KEYWORD',
  DAILO_SPEECH_TIMEOUT = 'DAILO_SPEECH_TIMEOUT',
  DAILO_SPEECH_HTTP_ERROR = 'DAILO_SPEECH_HTTP_ERROR',
  STOP_WORDS = 'STOP_WORDS',
  DAILO_STT_ERROR = 'DAILO_STT_ERROR',
  LESSON_TIME_LIMIT_EXPIRED = 'LESSON_TIME_LIMIT_EXPIRED'
}

export type EducationSessionPassedResult = {
  __typename?: 'EducationSessionPassedResult';
  branchId?: Maybe<Scalars['ID']>;
  scenarioId?: Maybe<Scalars['ID']>;
  passed: Scalars['Boolean'];
  interrupt: Scalars['Boolean'];
  recognizedText?: Maybe<Scalars['String']>;
  errorReason?: Maybe<EducationSessionErrorReason>;
};

export type EducationSessionProgress = {
  __typename?: 'EducationSessionProgress';
  sessionId: Scalars['ID'];
  level: Scalars['Int'];
  openedActions: Array<Scalars['ID']>;
  exposedActions: Array<Scalars['ID']>;
  lastMainScenarioAction?: Maybe<Scalars['ID']>;
  lastScenarioAction?: Maybe<Scalars['ID']>;
  lastScenarioId?: Maybe<Scalars['ID']>;
};

export enum EducationSessionRecordState {
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING',
  READY = 'READY',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export type EducationSessionResult = {
  __typename?: 'EducationSessionResult';
  sessionId: Scalars['ID'];
  passed: Scalars['Boolean'];
  score: Scalars['Int'];
  time: Scalars['TimeDeltaTimestamp'];
  usedHints: Scalars['Int'];
  requestFeedback: Scalars['Boolean'];
  record?: Maybe<Scalars['String']>;
  recordState: EducationSessionRecordState;
  actionResults: Array<ActionResult>;
  isContentMatches: Scalars['Boolean'];
  finishedScenariosIds: Array<Maybe<Scalars['ID']>>;
  parametricResults: Array<ParametricResult>;
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  feedbackScore?: Maybe<Scalars['Int']>;
  feedbackText?: Maybe<Scalars['String']>;
  feedbackContacts?: Maybe<Scalars['String']>;
  detailedFeedback: DetailedSessionFeedback;
  generalSentimentNeutral?: Maybe<Scalars['Int']>;
  generalSentimentPositive?: Maybe<Scalars['Int']>;
  generalSentimentNegative?: Maybe<Scalars['Int']>;
};

export type ErrorAudio = {
  __typename?: 'ErrorAudio';
  errorReason: UserInputErrorReason;
  filepath: Scalars['String'];
  gesture: AvatarGesture;
  emotion: AvatarEmotion;
  variantsCount: Scalars['Int'];
};

export type ExternalUser = {
  __typename?: 'ExternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export type FpsInput = {
  timestamp: Scalars['String'];
  fps: Scalars['Int'];
  deltaTime: Scalars['Int'];
};

/** An enumeration. */
export enum Gender {
  NOT_SET = 'NOT_SET',
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  users: Array<User>;
};

export type GroupInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  usersIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type HotWordsDictionary = {
  __typename?: 'HotWordsDictionary';
  id: Scalars['ID'];
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
};

export type HotWordsDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum LanguageCode {
  EN_US = 'EN_US',
  RU_RU = 'RU_RU'
}

export type Lesson = {
  __typename?: 'Lesson';
  id: Scalars['ID'];
  name: Scalars['String'];
  accessToken: Scalars['String'];
  createdAt: Scalars['DateTimeTimestamp'];
  lastUpdatedAt: Scalars['DateTimeTimestamp'];
  accountId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  avatar: Avatar;
  gestures: Array<Scalars['String']>;
  languageCode: LanguageCode;
  isInitial?: Maybe<Scalars['Boolean']>;
  recognitionEngine: LessonRecognitionEngine;
  recognitionAccuracy: LessonRecognitionAccuracy;
  mode: LessonMode;
  displayMode: LessonDisplayMode;
  inputMode: LessonInputMode;
  badWordsFilter: LessonBadWordsFilter;
  generateVideo?: Maybe<Scalars['Boolean']>;
  inviteByLink?: Maybe<Scalars['Boolean']>;
  useCharacterVoiceForErrors?: Maybe<Scalars['Boolean']>;
  muteNonUserSpeech?: Maybe<Scalars['Boolean']>;
  showPreviousPhrase?: Maybe<Scalars['Boolean']>;
  showDetailedResults?: Maybe<Scalars['Boolean']>;
  evaluateScenarios?: Maybe<Scalars['Boolean']>;
  evaluateQuizScore?: Maybe<Scalars['Boolean']>;
  selectableInputs?: Maybe<Scalars['Boolean']>;
  showResultsForEachParameter?: Maybe<Scalars['Boolean']>;
  startMessage?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  scormDownloadUrl: Scalars['String'];
  contentExportUrl?: Maybe<Scalars['String']>;
  canPlay?: Maybe<Scalars['Boolean']>;
  canResume?: Maybe<Scalars['Boolean']>;
  hasPassed?: Maybe<Scalars['Boolean']>;
  attemptsLimit?: Maybe<Scalars['Int']>;
  timeLimit?: Maybe<Scalars['Int']>;
  inputPhraseMaxLength?: Maybe<Scalars['Int']>;
  customParameters: Array<Scalars['String']>;
  avatarVoiceId?: Maybe<Scalars['String']>;
  systemVoiceId?: Maybe<Scalars['String']>;
};

export enum LessonBadWordsFilter {
  NO = 'NO',
  FAIL = 'FAIL',
  INTERRUPT = 'INTERRUPT'
}

export type LessonCourse = Lesson | Course;

export enum LessonDisplayMode {
  DEFAULT = 'DEFAULT',
  VIDEO_CALL = 'VIDEO_CALL'
}

export type LessonEducationState = {
  __typename?: 'LessonEducationState';
  status: LessonEducationStatus;
  bestAttempt?: Maybe<EducationSessionResult>;
  lastAttempt?: Maybe<EducationSessionResult>;
  canRetry: Scalars['Boolean'];
  attemptsCount?: Maybe<Scalars['Int']>;
  passedAttemptsCount?: Maybe<Scalars['Int']>;
  resultDescription?: Maybe<Scalars['String']>;
  lessonId?: Maybe<Scalars['ID']>;
};

export enum LessonEducationStatus {
  NOT_STARTED = 'NOT_STARTED',
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE'
}

export type LessonFilterInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  lessonMode?: Maybe<LessonMode>;
  courseId?: Maybe<Scalars['ID']>;
};

export type LessonInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  recognitionEngine?: Maybe<LessonRecognitionEngine>;
  recognitionAccuracy?: Maybe<LessonRecognitionAccuracy>;
  avatarId?: Maybe<Scalars['ID']>;
  courseId?: Maybe<Scalars['ID']>;
  mode?: Maybe<LessonMode>;
  displayMode?: Maybe<LessonDisplayMode>;
  inputMode?: Maybe<LessonInputMode>;
  badWordsFilter?: Maybe<LessonBadWordsFilter>;
  generateVideo?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  showDetailedResults?: Maybe<Scalars['Boolean']>;
  evaluateScenarios?: Maybe<Scalars['Boolean']>;
  evaluateQuizScore?: Maybe<Scalars['Boolean']>;
  selectableInputs?: Maybe<Scalars['Boolean']>;
  showResultsForEachParameter?: Maybe<Scalars['Boolean']>;
  inviteByLink?: Maybe<Scalars['Boolean']>;
  useCharacterVoiceForErrors?: Maybe<Scalars['Boolean']>;
  muteNonUserSpeech?: Maybe<Scalars['Boolean']>;
  showPreviousPhrase?: Maybe<Scalars['Boolean']>;
  startMessage?: Maybe<Scalars['String']>;
  resultMessage?: Maybe<Scalars['String']>;
  beforeLessonId?: Maybe<Scalars['ID']>;
  attemptsLimit?: Maybe<Scalars['Int']>;
  timeLimit?: Maybe<Scalars['Int']>;
  inputPhraseMaxLength?: Maybe<Scalars['Int']>;
  customParameters?: Maybe<Array<Scalars['String']>>;
  avatarVoiceId?: Maybe<Scalars['String']>;
  systemVoiceId?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum LessonInputMode {
  VOICE = 'VOICE',
  TEXT = 'TEXT'
}

/** An enumeration. */
export enum LessonMode {
  STUDY_THREE_STEP = 'STUDY_THREE_STEP',
  INTERVIEW = 'INTERVIEW',
  CHOICE_BASED_STUDY = 'CHOICE_BASED_STUDY',
  STUDY_TWO_STEP = 'STUDY_TWO_STEP',
  CHOICES_TEST_TWO_STEP = 'CHOICES_TEST_TWO_STEP',
  QUIZ = 'QUIZ',
  CHOICES_WITH_CUSTOM_SCORES = 'CHOICES_WITH_CUSTOM_SCORES',
  CUSTOM_PARAMETERS_TEST = 'CUSTOM_PARAMETERS_TEST'
}

export enum LessonOrderBy {
  ID = 'ID',
  NAME = 'NAME',
  CREATED_AT = 'CREATED_AT',
  LAST_UPDATED_AT = 'LAST_UPDATED_AT'
}

export type LessonParticipationSummary = {
  __typename?: 'LessonParticipationSummary';
  assignments: Scalars['Int'];
  started: Scalars['Int'];
  finished: Scalars['Int'];
  passed: Scalars['Int'];
};

export enum LessonRecognitionAccuracy {
  WEAK = 'WEAK',
  NORMAL = 'NORMAL',
  STRONG = 'STRONG'
}

export enum LessonRecognitionEngine {
  IDENTIFY = 'IDENTIFY',
  DAILOSPEECH = 'DAILOSPEECH'
}

/** An enumeration. */
export enum LessonScenarioActivationMethod {
  TRIGGER_PHRASE = 'TRIGGER_PHRASE',
  AVATAR_PHRASE = 'AVATAR_PHRASE',
  USER_INPUT = 'USER_INPUT'
}

/** An enumeration. */
export enum LessonScenarioAfterAction {
  RETURN = 'RETURN',
  NEXT = 'NEXT',
  INTERRUPT = 'INTERRUPT',
  FINISH = 'FINISH'
}

export type LoginSession = {
  __typename?: 'LoginSession';
  sessionId: Scalars['String'];
  user: User;
  account?: Maybe<Account>;
};

export type MembershipInput = {
  isActive: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  sendFeedback: Scalars['Boolean'];
  sendFpsMeasures: Scalars['Boolean'];
  educationSessionStart: SessionStartResult;
  educationSessionResume?: Maybe<EducationSessionProgress>;
  educationSessionFinish?: Maybe<EducationSessionResult>;
  educationSessionStartLevel?: Maybe<Scalars['Boolean']>;
  educationSessionUseHint?: Maybe<Scalars['Boolean']>;
  educationSessionSkip?: Maybe<Scalars['Boolean']>;
  educationSessionPass?: Maybe<EducationSessionPassedResult>;
  educationSessionPassStream?: Maybe<EducationSessionPassedResult>;
  educationSessionSubmitFeedback?: Maybe<Scalars['Boolean']>;
  educationSessionFinishScenario?: Maybe<Scalars['Boolean']>;
  educationSessionSelectRandomAvatarPhrase?: Maybe<Scalars['ID']>;
  educationSessionSelectInput?: Maybe<EducationSessionPassedResult>;
  addParticipants?: Maybe<Array<Participation>>;
  addLessonParticipants?: Maybe<Array<Participation>>;
  updateParticipation?: Maybe<Array<Participation>>;
  archiveParticipation?: Maybe<Array<Participation>>;
  tryInviteUserToLesson?: Maybe<Scalars['ID']>;
  recalculateSessionScore?: Maybe<Scalars['Boolean']>;
  addLesson?: Maybe<Lesson>;
  updateLesson?: Maybe<Lesson>;
  deleteLesson: Scalars['Boolean'];
  addCourse?: Maybe<Course>;
  updateCourse?: Maybe<Course>;
  deleteCourse: Scalars['Boolean'];
  addAvatarAction: AvatarAction;
  updateAvatarAction: AvatarAction;
  addUserInputAction: UserInputAction;
  updateUserInputAction: UserInputAction;
  addSystemAction: SystemAction;
  updateSystemAction: SystemAction;
  addChoiceUserInputAction: ChoiceUserInputAction;
  updateChoiceUserInputAction: ChoiceUserInputAction;
  addRandomAvatarAction: RandomAvatarAction;
  updateRandomAvatarAction: RandomAvatarAction;
  deleteAction: Scalars['Boolean'];
  addScenario?: Maybe<Scenario>;
  updateScenario?: Maybe<Scenario>;
  deleteScenario: Scalars['Boolean'];
  addTriggerDictionary?: Maybe<TriggerDictionaryType>;
  updateTriggerDictionary?: Maybe<TriggerDictionaryType>;
  deleteTriggerDictionary: Scalars['Boolean'];
  addCutWordsDictionary?: Maybe<CutWordsDictionary>;
  updateCutWordsDictionary?: Maybe<CutWordsDictionary>;
  deleteCutWordsDictionary: Scalars['Boolean'];
  addHotWordsDictionary?: Maybe<HotWordsDictionary>;
  updateHotWordsDictionary?: Maybe<HotWordsDictionary>;
  deleteHotWordsDictionary: Scalars['Boolean'];
  addResultDescription?: Maybe<ResultDescription>;
  updateResultDescription?: Maybe<ResultDescription>;
  deleteResultDescription: Scalars['Boolean'];
  addParametricResultDescription?: Maybe<ParametricResultDescription>;
  updateParametricResultDescription?: Maybe<ParametricResultDescription>;
  deleteParametricResultDescription: Scalars['Boolean'];
  copyLesson?: Maybe<Lesson>;
  copyCourse?: Maybe<Course>;
  updateChildren?: Maybe<Scalars['Boolean']>;
  login?: Maybe<LoginSession>;
  loginWithProvider?: Maybe<LoginSession>;
  loginSelectAccount?: Maybe<LoginSession>;
  signUp?: Maybe<SignUpStatus>;
  resetPassword: Scalars['Boolean'];
  resetPasswordSetPassword?: Maybe<LoginSession>;
  requestExtraAttempts: Scalars['Boolean'];
  requestLicenses: Scalars['Boolean'];
  updateMembership: User;
  setExperimentalMode: User;
  addUsers: Array<User>;
  setUsersActivity: Array<User>;
  setReportsReceive: Scalars['Boolean'];
  setExtraEmail: Scalars['Boolean'];
  importMembersCsv: Scalars['String'];
  addGroup?: Maybe<Group>;
  deleteGroup: Scalars['Boolean'];
  deactivateGroupMembers?: Maybe<Group>;
  updateGroup?: Maybe<Group>;
};


export type MutationSendFeedbackArgs = {
  actionId?: Maybe<Scalars['ID']>;
  attachment?: Maybe<Scalars['Upload']>;
  contact?: Maybe<Scalars['String']>;
  errorReason?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  sessionId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};


export type MutationSendFpsMeasuresArgs = {
  measures: Array<FpsInput>;
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionStartArgs = {
  externalUserId?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  preview?: Maybe<Scalars['Boolean']>;
  utm?: Maybe<Utm>;
};


export type MutationEducationSessionResumeArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  lessonId: Scalars['ID'];
};


export type MutationEducationSessionFinishArgs = {
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionStartLevelArgs = {
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionUseHintArgs = {
  actionId: Scalars['ID'];
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionSkipArgs = {
  actionId: Scalars['ID'];
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionPassArgs = {
  actionId: Scalars['ID'];
  audioUploadId?: Maybe<Scalars['ID']>;
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
  videoUploadId?: Maybe<Scalars['ID']>;
};


export type MutationEducationSessionPassStreamArgs = {
  actionId: Scalars['ID'];
  audioUploadId?: Maybe<Scalars['ID']>;
  duration?: Maybe<Scalars['Float']>;
  level: Scalars['Int'];
  recognizedText?: Maybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  sttError?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['ID'];
  videoUploadId?: Maybe<Scalars['ID']>;
};


export type MutationEducationSessionSubmitFeedbackArgs = {
  contacts?: Maybe<Scalars['String']>;
  data?: Maybe<DetailedSessionFeedbackInput>;
  message?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionFinishScenarioArgs = {
  actionId?: Maybe<Scalars['ID']>;
  level: Scalars['Int'];
  scenarioId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionSelectRandomAvatarPhraseArgs = {
  actionId: Scalars['ID'];
  level: Scalars['Int'];
  scenarioId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


export type MutationEducationSessionSelectInputArgs = {
  actionId: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  level: Scalars['Int'];
  sessionId: Scalars['ID'];
};


export type MutationAddParticipantsArgs = {
  courseId?: Maybe<Scalars['ID']>;
  emails?: Maybe<Array<Scalars['String']>>;
  lessonId?: Maybe<Scalars['ID']>;
  usersIds?: Maybe<Array<Scalars['ID']>>;
};


export type MutationAddLessonParticipantsArgs = {
  lessonId: Scalars['ID'];
  participants: Array<ParticipantInput>;
};


export type MutationUpdateParticipationArgs = {
  courseId?: Maybe<Scalars['ID']>;
  emails?: Maybe<Array<Scalars['String']>>;
  lessonId?: Maybe<Scalars['ID']>;
  status: Scalars['Boolean'];
  userId?: Maybe<Scalars['ID']>;
};


export type MutationArchiveParticipationArgs = {
  courseId?: Maybe<Scalars['ID']>;
  emails?: Maybe<Array<Scalars['String']>>;
  lessonId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};


export type MutationTryInviteUserToLessonArgs = {
  accessKey: Scalars['String'];
  lessonId: Scalars['ID'];
};


export type MutationRecalculateSessionScoreArgs = {
  sessionId: Scalars['ID'];
};


export type MutationAddLessonArgs = {
  data: LessonInput;
};


export type MutationUpdateLessonArgs = {
  data: LessonInput;
  id: Scalars['ID'];
};


export type MutationDeleteLessonArgs = {
  id: Scalars['ID'];
};


export type MutationAddCourseArgs = {
  data: CourseInput;
};


export type MutationUpdateCourseArgs = {
  data: CourseInput;
  id: Scalars['ID'];
};


export type MutationDeleteCourseArgs = {
  id: Scalars['ID'];
};


export type MutationAddAvatarActionArgs = {
  data: AvatarActionInput;
  lessonId: Scalars['ID'];
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateAvatarActionArgs = {
  actionId: Scalars['ID'];
  data: AvatarActionInput;
  lessonId: Scalars['ID'];
};


export type MutationAddUserInputActionArgs = {
  data: UserInputActionInput;
  lessonId: Scalars['ID'];
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateUserInputActionArgs = {
  actionId: Scalars['ID'];
  data: UserInputActionInput;
  lessonId: Scalars['ID'];
};


export type MutationAddSystemActionArgs = {
  data: SystemActionInput;
  lessonId: Scalars['ID'];
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateSystemActionArgs = {
  actionId: Scalars['ID'];
  data: SystemActionInput;
  lessonId: Scalars['ID'];
};


export type MutationAddChoiceUserInputActionArgs = {
  data: ChoiceUserInputActionInput;
  lessonId: Scalars['ID'];
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateChoiceUserInputActionArgs = {
  actionId: Scalars['ID'];
  data: ChoiceUserInputActionInput;
  lessonId: Scalars['ID'];
};


export type MutationAddRandomAvatarActionArgs = {
  data: RandomAvatarActionInput;
  lessonId: Scalars['ID'];
  scenarioId?: Maybe<Scalars['ID']>;
};


export type MutationUpdateRandomAvatarActionArgs = {
  actionId: Scalars['ID'];
  data: RandomAvatarActionInput;
  lessonId: Scalars['ID'];
};


export type MutationDeleteActionArgs = {
  actionId: Scalars['ID'];
  lessonId: Scalars['ID'];
};


export type MutationAddScenarioArgs = {
  data: ScenarioInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateScenarioArgs = {
  data: ScenarioInput;
  lessonId: Scalars['ID'];
  scenarioId: Scalars['ID'];
};


export type MutationDeleteScenarioArgs = {
  lessonId: Scalars['ID'];
  scenarioId: Scalars['ID'];
};


export type MutationAddTriggerDictionaryArgs = {
  data: TriggerDictionaryInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateTriggerDictionaryArgs = {
  data: TriggerDictionaryInput;
  lessonId: Scalars['ID'];
  triggerDictionaryId: Scalars['ID'];
};


export type MutationDeleteTriggerDictionaryArgs = {
  lessonId: Scalars['ID'];
  triggerDictionaryId: Scalars['ID'];
};


export type MutationAddCutWordsDictionaryArgs = {
  data: CutWordsDictionaryInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateCutWordsDictionaryArgs = {
  cutWordsDictionaryId: Scalars['ID'];
  data: CutWordsDictionaryInput;
  lessonId: Scalars['ID'];
};


export type MutationDeleteCutWordsDictionaryArgs = {
  cutWordsDictionaryId: Scalars['ID'];
  lessonId: Scalars['ID'];
};


export type MutationAddHotWordsDictionaryArgs = {
  data: HotWordsDictionaryInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateHotWordsDictionaryArgs = {
  data: HotWordsDictionaryInput;
  hotWordsDictionaryId: Scalars['ID'];
  lessonId: Scalars['ID'];
};


export type MutationDeleteHotWordsDictionaryArgs = {
  hotWordsDictionaryId: Scalars['ID'];
  lessonId: Scalars['ID'];
};


export type MutationAddResultDescriptionArgs = {
  data: ResultDescriptionInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateResultDescriptionArgs = {
  data: ResultDescriptionInput;
  lessonId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationDeleteResultDescriptionArgs = {
  lessonId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationAddParametricResultDescriptionArgs = {
  data: ParametricResultDescriptionInput;
  lessonId: Scalars['ID'];
};


export type MutationUpdateParametricResultDescriptionArgs = {
  data: ParametricResultDescriptionInput;
  lessonId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationDeleteParametricResultDescriptionArgs = {
  lessonId: Scalars['ID'];
  resultDescriptionId: Scalars['ID'];
};


export type MutationCopyLessonArgs = {
  id: Scalars['ID'];
};


export type MutationCopyCourseArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateChildrenArgs = {
  courseId?: Maybe<Scalars['ID']>;
  lessonId?: Maybe<Scalars['ID']>;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginWithProviderArgs = {
  provider: Scalars['String'];
  token: Scalars['String'];
};


export type MutationLoginSelectAccountArgs = {
  accountId?: Maybe<Scalars['ID']>;
};


export type MutationSignUpArgs = {
  accountId?: Maybe<Scalars['ID']>;
  fullname: Scalars['String'];
  isDemo?: Maybe<Scalars['Boolean']>;
  languageCode: LanguageCode;
  password: Scalars['String'];
  repeatPassword: Scalars['String'];
  username: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
  languageCode?: Maybe<LanguageCode>;
};


export type MutationResetPasswordSetPasswordArgs = {
  hash: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationRequestExtraAttemptsArgs = {
  comment?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};


export type MutationRequestLicensesArgs = {
  correspondenceAddress?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  customerType: CustomerType;
  duration: Scalars['Int'];
  languageCode: LanguageCode;
  legalAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['Int']>;
  trrc?: Maybe<Scalars['Int']>;
};


export type MutationUpdateMembershipArgs = {
  data: MembershipInput;
  userId: Scalars['ID'];
};


export type MutationSetExperimentalModeArgs = {
  experimentalMode: Scalars['Boolean'];
};


export type MutationAddUsersArgs = {
  emails: Array<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  names: Array<Scalars['String']>;
};


export type MutationSetUsersActivityArgs = {
  emails: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
};


export type MutationSetReportsReceiveArgs = {
  status: Scalars['Boolean'];
};


export type MutationSetExtraEmailArgs = {
  email: Scalars['String'];
};


export type MutationImportMembersCsvArgs = {
  attachment: Scalars['Upload'];
  emailLanguage: LanguageCode;
  overrideActive: Scalars['Boolean'];
  sendWelcomeEmails: Scalars['Boolean'];
};


export type MutationAddGroupArgs = {
  data: GroupInput;
};


export type MutationDeleteGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeactivateGroupMembersArgs = {
  groupId: Scalars['ID'];
};


export type MutationUpdateGroupArgs = {
  data: GroupInput;
  id: Scalars['ID'];
};

export type Order = {
  __typename?: 'Order';
  licensesCount: Scalars['Int'];
  licensesDuration: Scalars['Int'];
};

export type ParametricResult = {
  __typename?: 'ParametricResult';
  parameterName: Scalars['String'];
  score: Scalars['Int'];
};

export type ParametricResultCondition = {
  __typename?: 'ParametricResultCondition';
  parameter?: Maybe<Scalars['String']>;
  minValue?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
};

export type ParametricResultConditionInput = {
  parameter?: Maybe<Scalars['String']>;
  minValue?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
};

export type ParametricResultDescription = {
  __typename?: 'ParametricResultDescription';
  id: Scalars['ID'];
  conditions: Array<ParametricResultCondition>;
  message?: Maybe<Scalars['String']>;
};

export type ParametricResultDescriptionInput = {
  conditions?: Maybe<Array<ParametricResultConditionInput>>;
  message?: Maybe<Scalars['String']>;
};

export type ParticipantInput = {
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type Participation = {
  __typename?: 'Participation';
  id: Scalars['ID'];
  student: Student;
  lesson: Lesson;
  attemptsCount: Scalars['Int'];
  attemptsTotalTime: Scalars['TimeDeltaTimestamp'];
  firstAttempt?: Maybe<EducationSessionResult>;
  bestAttempt?: Maybe<EducationSessionResult>;
  lastAttempt?: Maybe<EducationSessionResult>;
  isActive: Scalars['Boolean'];
  /** @deprecated Moved to session */
  feedbackScore?: Maybe<Scalars['Int']>;
  /** @deprecated Moved to session */
  feedbackText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeTimestamp'];
  startedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  invited: Scalars['Boolean'];
  invitedAt?: Maybe<Scalars['DateTimeTimestamp']>;
  /** @deprecated use invited */
  inviteSent: Scalars['Boolean'];
  /** @deprecated use invitedAt */
  inviteSentAt?: Maybe<Scalars['DateTimeTimestamp']>;
};

export enum PitchRange {
  MONOTONIC = 'MONOTONIC',
  REASONABLE = 'REASONABLE',
  EXPRESSIVE = 'EXPRESSIVE'
}

export type Query = {
  __typename?: 'Query';
  getDashboardData: SelectedDashboardData;
  getCourseResultsByUser: SelectedDashboardData;
  getLessonResults?: Maybe<Array<EducationSessionResult>>;
  getAssignedLessons?: Maybe<Array<LessonCourse>>;
  getSessionResult?: Maybe<EducationSessionResult>;
  getLessonEducationState?: Maybe<LessonEducationState>;
  getLessonsEducationState?: Maybe<Array<LessonEducationState>>;
  getAccountMembers: EducationMembersPaginatedList;
  getAccountMembersSummary: EducationMembersSummary;
  getAccountParticipationsExportUrl: Scalars['String'];
  getAccountUsersExportUrl: Scalars['String'];
  getParticipationsSummary: LessonParticipationSummary;
  getStreamingSpeechAnalysis?: Maybe<Array<SessionSpeechAnalysis>>;
  getLessons: Array<LessonCourse>;
  getCourse?: Maybe<Course>;
  getCourses: Array<Course>;
  getLesson?: Maybe<Lesson>;
  getLessonActions?: Maybe<Array<Action>>;
  getLessonScenarios?: Maybe<Array<Scenario>>;
  getLessonTriggerDictionaries?: Maybe<Array<TriggerDictionaryType>>;
  getLessonCutWordsDictionaries?: Maybe<Array<CutWordsDictionary>>;
  getLessonHotWordsDictionaries?: Maybe<Array<HotWordsDictionary>>;
  getLessonResultDescriptions?: Maybe<Array<ResultDescription>>;
  getLessonParametricResultDescriptions?: Maybe<Array<ParametricResultDescription>>;
  getNextLesson?: Maybe<Lesson>;
  getSupportedVoices?: Maybe<Array<Scalars['String']>>;
  getAvatars: Array<Avatar>;
  getErrorsAudio?: Maybe<Array<ErrorAudio>>;
  getAvailableAccounts: Array<Account>;
  getCurrentAccount?: Maybe<Account>;
  getCurrentUser?: Maybe<User>;
  getResetPasswordUser?: Maybe<ResetPasswordInformation>;
  getAccountByLesson?: Maybe<AccountBase>;
  getExternalUser?: Maybe<ExternalUser>;
  getAccountContracts?: Maybe<Array<Contract>>;
  getGroups?: Maybe<Array<Group>>;
  getUsersByMixedData?: Maybe<UsersByMixedData>;
  getCurrentAccountUsers?: Maybe<Array<User>>;
  getEditorAccessType?: Maybe<EditorAccessType>;
  getNotApprovedOrders?: Maybe<Array<Order>>;
};


export type QueryGetDashboardDataArgs = {
  dataType?: Maybe<DashboardDataType>;
  filter?: Maybe<DashboardDataFilterInput>;
};


export type QueryGetCourseResultsByUserArgs = {
  courseId: Scalars['ID'];
};


export type QueryGetLessonResultsArgs = {
  lessonId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type QueryGetSessionResultArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
};


export type QueryGetLessonEducationStateArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  lessonId: Scalars['ID'];
};


export type QueryGetLessonsEducationStateArgs = {
  courseId?: Maybe<Scalars['ID']>;
};


export type QueryGetAccountMembersArgs = {
  filter?: Maybe<EducationMemberFilterInput>;
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetAccountParticipationsExportUrlArgs = {
  variant?: Maybe<Scalars['String']>;
};


export type QueryGetAccountUsersExportUrlArgs = {
  filter?: Maybe<EducationMemberFilterInput>;
  variant?: Maybe<Scalars['String']>;
};


export type QueryGetParticipationsSummaryArgs = {
  courseId?: Maybe<Scalars['ID']>;
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  lessonId?: Maybe<Scalars['ID']>;
};


export type QueryGetStreamingSpeechAnalysisArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
};


export type QueryGetLessonsArgs = {
  filter?: Maybe<LessonFilterInput>;
  flatMode?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<LessonOrderBy>;
};


export type QueryGetCourseArgs = {
  courseId?: Maybe<Scalars['ID']>;
  lessonId?: Maybe<Scalars['ID']>;
};


export type QueryGetLessonArgs = {
  externalUserId?: Maybe<Scalars['ID']>;
  lessonId: Scalars['ID'];
};


export type QueryGetLessonActionsArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonScenariosArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonTriggerDictionariesArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonCutWordsDictionariesArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonHotWordsDictionariesArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonResultDescriptionsArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetLessonParametricResultDescriptionsArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetNextLessonArgs = {
  courseId?: Maybe<Scalars['ID']>;
  lessonId: Scalars['ID'];
};


export type QueryGetErrorsAudioArgs = {
  voice: Scalars['String'];
};


export type QueryGetResetPasswordUserArgs = {
  hash: Scalars['String'];
};


export type QueryGetAccountByLessonArgs = {
  lessonId: Scalars['ID'];
};


export type QueryGetExternalUserArgs = {
  externalUserId: Scalars['ID'];
  lessonId: Scalars['ID'];
};


export type QueryGetUsersByMixedDataArgs = {
  groupsIds?: Maybe<Array<Scalars['ID']>>;
  plainText?: Maybe<Scalars['String']>;
  usersIds?: Maybe<Array<Scalars['ID']>>;
};

export type RandomAvatarAction = Action & {
  __typename?: 'RandomAvatarAction';
  id: Scalars['ID'];
  branches: Array<RandomAvatarActionBranch>;
};

export type RandomAvatarActionBranch = {
  __typename?: 'RandomAvatarActionBranch';
  id: Scalars['ID'];
  avatarAction?: Maybe<AvatarAction>;
  targetScenarioId?: Maybe<Scalars['ID']>;
  dropChance?: Maybe<Scalars['Float']>;
};

export type RandomAvatarActionBranchInput = {
  id?: Maybe<Scalars['ID']>;
  targetScenarioId?: Maybe<Scalars['ID']>;
  dropChance?: Maybe<Scalars['Float']>;
  avatarAction?: Maybe<AvatarActionInput>;
};

export type RandomAvatarActionInput = {
  beforeActionId?: Maybe<Scalars['ID']>;
  branches?: Maybe<Array<RandomAvatarActionBranchInput>>;
};

export type ResetPasswordInformation = {
  __typename?: 'ResetPasswordInformation';
  email: Scalars['String'];
};

export type ResultDescription = {
  __typename?: 'ResultDescription';
  id: Scalars['ID'];
  minScore: Scalars['Int'];
  maxScore: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
};

export type ResultDescriptionInput = {
  minScore?: Maybe<Scalars['Int']>;
  maxScore?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
};

export type Scenario = {
  __typename?: 'Scenario';
  id: Scalars['ID'];
  name: Scalars['String'];
  isMain: Scalars['Boolean'];
  triggerPhrases: Array<Scalars['String']>;
  afterAction: LessonScenarioAfterAction;
  activationMethod: LessonScenarioActivationMethod;
  actions: Array<Action>;
};

export type ScenarioInput = {
  name?: Maybe<Scalars['String']>;
  triggerPhrases?: Maybe<Array<Scalars['String']>>;
  afterAction?: Maybe<LessonScenarioAfterAction>;
  activationMethod?: Maybe<LessonScenarioActivationMethod>;
};

export type SelectedDashboardData = {
  __typename?: 'SelectedDashboardData';
  totalTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
  assigned?: Maybe<Scalars['Int']>;
  started?: Maybe<Scalars['Int']>;
  passed?: Maybe<Scalars['Int']>;
  noHints?: Maybe<Scalars['Int']>;
  byScore?: Maybe<Scalars['Int']>;
  notFinished?: Maybe<Scalars['Int']>;
  badWord?: Maybe<Scalars['Int']>;
  avgScore?: Maybe<Scalars['Float']>;
  avgFeedbackScore?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  byLesson: Array<DashboardDataByLesson>;
};

export type SessionSpeechAnalysis = {
  __typename?: 'SessionSpeechAnalysis';
  actionId: Scalars['ID'];
  pitchRange?: Maybe<PitchRange>;
  speechSpeed?: Maybe<SpeechSpeed>;
};

export type SessionStartResult = {
  __typename?: 'SessionStartResult';
  sessionId: Scalars['ID'];
  recognitionEngine?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SignUpStatus {
  SUCCESS = 'SUCCESS',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  SHORT_PASSWORD = 'SHORT_PASSWORD',
  SHORT_USERNAME = 'SHORT_USERNAME',
  PASSWORDS_ARE_NOT_EQUAL = 'PASSWORDS_ARE_NOT_EQUAL',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export enum SpeechSpeed {
  SLOW = 'SLOW',
  REASONABLE = 'REASONABLE',
  FAST = 'FAST'
}

export type Student = User & {
  __typename?: 'Student';
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  demoAccessed: Scalars['Boolean'];
  demoDaysRemaining?: Maybe<Scalars['Int']>;
  isEmailActivated?: Maybe<Scalars['Boolean']>;
};

export type SystemAction = Action & {
  __typename?: 'SystemAction';
  id: Scalars['ID'];
  audio?: Maybe<Scalars['String']>;
  isCustomAudio: Scalars['Boolean'];
  media?: Maybe<Scalars['String']>;
  mediaType?: Maybe<Scalars['String']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  onlyFirstLevel: Scalars['Boolean'];
};

export type SystemActionInput = {
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['Upload']>;
  mediaViewRequired?: Maybe<Scalars['Boolean']>;
  setMediaAsBackground?: Maybe<Scalars['Boolean']>;
  onlyFirstLevel?: Maybe<Scalars['Boolean']>;
  customAudio?: Maybe<Scalars['Upload']>;
  regenerateAudio?: Maybe<Scalars['Boolean']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};


export type TriggerDictionaryInput = {
  name?: Maybe<Scalars['String']>;
  languageCode?: Maybe<LanguageCode>;
  phrases?: Maybe<Scalars['String']>;
};

export type TriggerDictionaryType = {
  __typename?: 'TriggerDictionaryType';
  id: Scalars['ID'];
  name: Scalars['String'];
  languageCode: LanguageCode;
  phrases: Scalars['String'];
};

export type Utm = {
  source?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  campaign?: Maybe<Scalars['String']>;
  term?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};


export type User = {
  id: Scalars['ID'];
  name: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  extraEmail?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  isDeveloper: Scalars['Boolean'];
  isExperimental: Scalars['Boolean'];
  experimentalMode: Scalars['Boolean'];
  hasActiveMembership: Scalars['Boolean'];
  accountsCount: Scalars['Int'];
  groups: Array<Group>;
  demoAccessed: Scalars['Boolean'];
  demoDaysRemaining?: Maybe<Scalars['Int']>;
  isEmailActivated?: Maybe<Scalars['Boolean']>;
};

export type UserInputAction = Action & {
  __typename?: 'UserInputAction';
  id: Scalars['ID'];
  expectedText: Scalars['String'];
  rawExpectedText: Scalars['String'];
  hintText: Scalars['String'];
  analogTexts: Array<Scalars['String']>;
  freeSpeech?: Maybe<Scalars['Boolean']>;
  freeSpeechMinTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
  freeSpeechMaxTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
};

export type UserInputActionInput = {
  expectedText?: Maybe<Scalars['String']>;
  analogTexts?: Maybe<Array<Scalars['String']>>;
  hintText?: Maybe<Scalars['String']>;
  freeSpeech?: Maybe<Scalars['Boolean']>;
  freeSpeechMinTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
  freeSpeechMaxTime?: Maybe<Scalars['TimeDeltaTimestamp']>;
  beforeActionId?: Maybe<Scalars['ID']>;
};

/** An enumeration. */
export enum UserInputErrorReason {
  NO_ANSWER = 'NO_ANSWER',
  WRONG_ANSWER = 'WRONG_ANSWER',
  BAD_WORD = 'BAD_WORD',
  TIME_EXPIRED = 'TIME_EXPIRED',
  WRONG_CHOICE = 'WRONG_CHOICE',
  MISSING_KEYWORD = 'MISSING_KEYWORD',
  DAILO_SPEECH_TIMEOUT = 'DAILO_SPEECH_TIMEOUT',
  DAILO_SPEECH_HTTP_ERROR = 'DAILO_SPEECH_HTTP_ERROR',
  STOP_WORDS = 'STOP_WORDS',
  DAILO_STT_ERROR = 'DAILO_STT_ERROR',
  LESSON_TIME_LIMIT_EXPIRED = 'LESSON_TIME_LIMIT_EXPIRED'
}

export type UsersByMixedData = {
  __typename?: 'UsersByMixedData';
  users: Array<User>;
  emails?: Maybe<Array<Scalars['String']>>;
};
